/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request body for bulk ship information query. Provide one of mmsi array, imo array, or shiplist name.
 * @export
 * @interface ShipInfoBulkRequest
 */
export interface ShipInfoBulkRequest {
    /**
     * List of MMSI identifiers
     * @type {Array<number>}
     * @memberof ShipInfoBulkRequest
     */
    mmsi?: Array<number>;
    /**
     * List of IMO numbers
     * @type {Array<number>}
     * @memberof ShipInfoBulkRequest
     */
    imo?: Array<number>;
    /**
     * Name of a predefined shiplist
     * @type {string}
     * @memberof ShipInfoBulkRequest
     */
    shiplist?: string;
}

/**
 * Check if a given object implements the ShipInfoBulkRequest interface.
 */
export function instanceOfShipInfoBulkRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipInfoBulkRequestFromJSON(json: any): ShipInfoBulkRequest {
    return ShipInfoBulkRequestFromJSONTyped(json, false);
}

export function ShipInfoBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipInfoBulkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'shiplist': !exists(json, 'shiplist') ? undefined : json['shiplist'],
    };
}

export function ShipInfoBulkRequestToJSON(value?: ShipInfoBulkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
        'imo': value.imo,
        'shiplist': value.shiplist,
    };
}

